import { fetchDocuments } from '@/lib/api';

export default {
  state: {
    documents: {},
    loading: true,
  },
  getters: {
    isLoadingDocuments(state) {
      return state.loading;
    },
    documents(state) {
      return state.documents;
    },
  },
  mutations: {
    setLoadingDocuments(state, loading) {
      state.loading = loading;
    },
    updateDocuments(state, documents) {
      state.documents = documents;
    },
  },
  actions: {
    async fetchDocuments({ commit }, clientId) {
      commit('setLoadingDocuments', true);
      const documents = await fetchDocuments.execute(clientId);
      commit('updateDocuments', documents);
      commit('setLoadingDocuments', false);

      return documents;
    },
  },
};
